import { render, staticRenderFns } from "./ProductDetailsView.vue?vue&type=template&id=d476b2e0&scoped=true&"
import script from "./ProductDetailsView.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d476b2e0",
  null
  
)

export default component.exports